function resolveElements(elementOrSelector, scope, selectorCache) {
  if (elementOrSelector instanceof EventTarget) {
    return [elementOrSelector];
  } else if (typeof elementOrSelector === "string") {
    var _selectorCache$elemen;

    var root = document;

    if (scope) {
      root = scope.current;
    }

    var elements = (_selectorCache$elemen = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _selectorCache$elemen !== void 0 ? _selectorCache$elemen : root.querySelectorAll(elementOrSelector);
    return elements ? Array.from(elements) : [];
  }

  return Array.from(elementOrSelector);
}

export { resolveElements };